import { render } from "./ThemeChanger.vue?vue&type=template&id=06469bd4"
import script from "./ThemeChanger.vue?vue&type=script&lang=js"
export * from "./ThemeChanger.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__